<template>
    <div class="rights-page">
        <h2>系统正在升级，敬请期待。</h2>
    </div>
    
</template>
<script>
import { Toast, Dialog, Loading, Overlay } from 'vant';
import { selectPayState } from '@/api';
export default {
    name: 'rights',
    data() {
        return {
            payNo: '',
            loading: true,
            payResult: '',
            payShow: false
        }
    }
}
</script>
<style scoped lang="less">
.rights-page {
    text-align: center;
    padding: 0 40px;
    color: #333;
    &_title {
        color: #4e8fe0;
        font-size: 50px;
        margin: 70px 0 40px;
    }
    h2 {
        font-size: 20px;
        margin-bottom: 40px;
    }
}
.loadingDiv {
    position: absolute;
    left: 35%;
    top: 40%;
}
</style>